export type Entitlements = {
  pack?: string;
  pbp_cap?: string;
  wire_plan?: string;
  onair?: boolean;
  line_plan?: string;
  clips?: boolean;
  office?: boolean;
  hall?: boolean;
  social?: boolean;
  scouting?: boolean;
  white_label?: boolean;
};

export type PortalProfile = {
  parent_client_id?: string | null;
  portal_kind?: 'league' | 'club' | 'press' | string;
  wire_plan?: string;
  onair_enabled?: boolean;
  line_plan?: string;
  product_pack?: string;
  entitlements?: Entitlements;
};

export function entitlementsOf(me?: PortalProfile | null): Entitlements {
  const e = me?.entitlements ?? {};
  return {
    pack: e.pack || me?.product_pack,
    pbp_cap: e.pbp_cap,
    wire_plan: e.wire_plan || me?.wire_plan || 'off',
    onair: e.onair ?? !!me?.onair_enabled,
    line_plan: e.line_plan || me?.line_plan || 'off',
    clips: !!e.clips,
    office: !!e.office,
    hall: !!e.hall,
    social: e.social ?? ((e.wire_plan || me?.wire_plan || 'off') !== 'off'),
    scouting: !!e.scouting,
    white_label: !!e.white_label,
  };
}

export function hasWire(me?: PortalProfile | null): boolean {
  const w = entitlementsOf(me).wire_plan;
  return !!w && w !== 'off';
}

export function hasOnAir(me?: PortalProfile | null): boolean {
  return !!entitlementsOf(me).onair;
}

export function hasLine(me?: PortalProfile | null): boolean {
  const p = entitlementsOf(me).line_plan;
  return !!p && p !== 'off';
}

export function hasClips(me?: PortalProfile | null): boolean {
  return !!entitlementsOf(me).clips;
}

export function hasOffice(me?: PortalProfile | null): boolean {
  return !!entitlementsOf(me).office;
}

export function hasHall(me?: PortalProfile | null): boolean {
  return !!entitlementsOf(me).hall;
}

export function hasSocial(me?: PortalProfile | null): boolean {
  return !!entitlementsOf(me).social;
}

export function hasScouting(me?: PortalProfile | null): boolean {
  return !!entitlementsOf(me).scouting;
}

export function hasWhiteLabel(me?: PortalProfile | null): boolean {
  return !!entitlementsOf(me).white_label;
}

export function portalKind(me?: PortalProfile | null): 'league' | 'club' | 'press' {
  if (me?.portal_kind === 'press' || me?.portal_kind === 'club' || me?.portal_kind === 'league') {
    return me.portal_kind;
  }
  return me?.parent_client_id ? 'club' : 'league';
}

export function isClubLogin(me?: PortalProfile | null): boolean {
  return portalKind(me) === 'club';
}

export function isLeagueLogin(me?: PortalProfile | null): boolean {
  return portalKind(me) === 'league';
}

export function isPressLogin(me?: PortalProfile | null): boolean {
  return portalKind(me) === 'press';
}

export function portalHomePath(me?: PortalProfile | null): string {
  return portalKind(me) === 'club' ? '/home' : '/matches';
}
